import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDestination = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 43,
	viewBox: "0 0 36 43",
	width: 36,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 18,
			fill: "#009fe3",
			r: 18
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m-10.13-.86 4.31-5.25h-4.21v-.99h5.52v.86l-4.21 5.25h4.22v.99h-5.63zm6.78.86v-7.1h1.12v7.1zm7.59-.99v.99h-4.87v-7.1h4.78v.99h-3.66v2.02h3.17v.93h-3.17v2.17zm1.16.99v-7.1h1.12v6.11h3.81v.99z",
			fill: "#fff",
			transform: "translate(18 22)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m7.5 0 7.5 13h-15z",
			fill: "#009fe3",
			transform: "matrix(-1 0 0 -1 26 43)"
		})
	]
});
export default SvgDestination;
